import type { TerritoryContentFilters } from 'generated/graphql'

// Returns `undefined` (not `null`) when unscoped so that consumers spreading it
// into Apollo `variables` omit `$territoryContentFilters` from the request
// entirely — keeping unscoped requests byte-identical to today, instead of
// sending an explicit `territoryContentFilters: null` the backend would have to
// interpret.
export const buildContentFilters = (territoryIds: string[] | null): TerritoryContentFilters | undefined =>
  territoryIds && territoryIds.length > 0 ? { territoryIds } : undefined
